import { EventEmitter, Injectable } from '@angular/core';
import { AdminService } from './admin/admin.service';
import { AuthService } from './auth.service';
import { Hotkey } from 'app/_models/admin/hotkey';
import { HotkeyModifierKeyKind } from 'app/_models/admin/hotkey.modifier.key.kind';

@Injectable({
  providedIn: 'root'
})
export class HotkeyService {
  hotkeyEmitters: { [key: string]: EventEmitter<KeyboardEvent[]> } = {};
  lastEvents: KeyboardEvent[] = []
  debugMode = false;

  constructor(
    private adminService: AdminService,
    private authService: AuthService
  ) { }

  handleHotkeyEvent(event: KeyboardEvent) {
    const tagName = event.currentTarget['activeElement']?.tagName;
    const keys = [];
    if (event.altKey) keys.push('ALT');
    if (event.ctrlKey) keys.push('CONTROL');
    if (event.metaKey) keys.push('META');
    if (event.shiftKey) keys.push('SHIFT');

    // if (tagName !== 'INPUT') {
    //   console.info(`${tagName}  ${keys.join('+')} ${event.key} pressed.`);
    // }

    if (this.lastEvents[0] && this.lastEvents[0].shiftKey && this.lastEvents[0].ctrlKey && !this.lastEvents[0].altKey && this.lastEvents[0].key === 'S' && event.shiftKey && event.ctrlKey && !event.altKey && event.key === 'D') {
      this.debugMode = !this.debugMode;
      console.info(`Debug Mode = ${this.debugMode ? 'ON' : 'OFF'}`);
    }

    this.lastEvents.unshift(event);

    Object.keys(this.hotkeyEmitters).forEach(key => this.hotkeyEmitters[key].emit(this.lastEvents));
  }



  addHotkeyEvent(key: string, hotkeyEmitter: EventEmitter<KeyboardEvent[]>) {
    if (key in this.hotkeyEmitters) delete this.hotkeyEmitters[key];
    this.hotkeyEmitters[key] = hotkeyEmitter;
  }

  removeHotkeyEvent(key: string) {
    if (key in this.hotkeyEmitters) {
      this.hotkeyEmitters[key].unsubscribe();
      delete this.hotkeyEmitters[key];
    }
  }

  getHotKeyHtml(hotkeys: Hotkey[]): string {
    if (!hotkeys || hotkeys.length === 0) return null;
    var hotkeyHtml = '';
    hotkeys.forEach(hotkey => {
      if (hotkeyHtml.length > 0) hotkeyHtml += '+';
      if ((hotkey.ModifierKeys & HotkeyModifierKeyKind.ShiftKey) !== 0) hotkeyHtml += '&#8679;';
      if ((hotkey.ModifierKeys & HotkeyModifierKeyKind.CtrlKey) !== 0) hotkeyHtml += '&#8963;';
      if ((hotkey.ModifierKeys & HotkeyModifierKeyKind.AltKey) !== 0) hotkeyHtml += '&#8997';
      if ((hotkey.ModifierKeys & HotkeyModifierKeyKind.MetaKey) !== 0) hotkeyHtml += '&#8984;';
      if (hotkey.Key) hotkeyHtml += hotkey.Key.toUpperCase();
      

    });
    return hotkeyHtml;
  }

}
